if (document.querySelector('.footer')) {
  const paragraph = document.createElement('p');
  paragraph.innerHTML = document
    .querySelector('.footer')
    .querySelector('p').innerHTML;
  document.querySelector('.footer').append(paragraph);
}
const setSize = function () {
  if (document.querySelector('.section__wrapper#o-plebiscycie')) {
    document
      .querySelector('.section__wrapper#o-plebiscycie')
      .style.setProperty(
        '--mask-height',
        Math.ceil(
          document
            .querySelectorAll('.section__wrapper#o-plebiscycie .wrapper')[0]
            .getBoundingClientRect().height
        ) + 'px'
      );
  }
  if (document.querySelectorAll('.article--ajax-wrapper').length > 0) {
    document
      .querySelectorAll('.article--ajax-wrapper')[0]
      .style.setProperty(
        '--mask-height',
        Math.ceil(
          document
            .querySelectorAll('.article--ajax-wrapper')[0]
            .querySelectorAll('.article__heading')[0]
            .getBoundingClientRect().height
        ) + 'px'
      );
  }
  if (document.querySelector('.teasers-categories')) {
    document
      .querySelector('.teasers-categories')
      .querySelectorAll('.teaser__category')
      .forEach(function (text) {
        const elWidth =
          text.querySelector('h4').getBoundingClientRect().width >
          text.querySelector('p').getBoundingClientRect().width
            ? text.querySelector('h4').getBoundingClientRect().width
            : text.querySelector('p').getBoundingClientRect().width;
        text.style.setProperty('--text-width', Math.ceil(elWidth) + 'px');
      });
  }
};

window.addEventListener('DOMContentLoaded', () => {
  setSize();
});
window.addEventListener('load', () => {
  setSize();
});
window.addEventListener('resize', (event) => {
  setSize();
});
